import React from "react";
import "./WhurzIt.css"

const WhurzItFour = () => (
  <div>

	<h1>Data Storage</h1>
    <p>WhurzIt uses Google <a href={"https://firebase.google.com//"} 
    target={"_blank"}>Firebase</a> to store its data.</p>

    <p>The data is stored as two encrypted strings that are arrays of encrypted
    JSON strings of item and place objects.</p>

  </div>
);

export default WhurzItFour;


// WEBPACK FOOTER //
// ./src/components/WhurzIt/WhurzItFour.js